import React from "react"
import {FieldTableCellProps, getTableCellStyle} from "../../../../render/table/table-cell";
import {FieldViewSize} from "../../../../const";
import FieldPriority_Editable from "../editable/editable";

export default function FieldPriority_TableCell(props:FieldTableCellProps):React.ReactElement {

    const onChange = (value:any) => {
        props.field.fieldParams.tableCellOnValueChange!(props.listItem, value, props.manager)
    }

    return (
        <div className="cell-flex p-h-0" style={getTableCellStyle(props)}>

            <FieldPriority_Editable size        = {FieldViewSize.SMALL}
                                    iconOnly    = {props.column.width!<80}
                                    className   = "w-100-percent h-100-percent"
                                    disabled    = {props.manager.isReadOnly}
                                    field       = {props.field}
                                    model       = {props.listItem.item}
                                    onChange    = {onChange} />

        </div>

    )

}
